/** Trigger a browser download for a Blob via a transient object URL. */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

/** Open a Blob (e.g. a PDF) in a new browser tab for inline viewing. */
export function openBlobInNewTab(blob: Blob): void {
  const url = URL.createObjectURL(blob)
  window.open(url, '_blank', 'noopener,noreferrer')
  // Keep the URL alive long enough for the new tab to load it.
  setTimeout(() => URL.revokeObjectURL(url), 60_000)
}
